export interface IWidthColumnOrdersInTransportTable {
  CheckBox: string;
  FulfilledBy: string;
  OrderNumber: string;

  ClientName: string;
  ClientNameTitle: string;

  CarrierName: string;
  CarrierNameTitle: string;

  CurrentStateDescription: string;
  CurrentStateDescriptionTitle: string;

  VirtualCollect: string;
  VirtualCollectTitle: string;

  LastConsult: string;
  LastConsultTitle: string;

  LastStatusPackage: string;
  LastStatusPackageTitle: string;

  Options: string;
  OptionsTitle: string;
}

export function useOrdersInTransportTable() {

  function getWidthColumns(): IWidthColumnOrdersInTransportTable {
    return {
      CheckBox: '30px',
      FulfilledBy: '30px',
      OrderNumber: '100px',

      CarrierName: '135px',
      CarrierNameTitle: '135px',

      ClientName: '15%',
      ClientNameTitle: '15%',

      CurrentStateDescription: '17%',
      CurrentStateDescriptionTitle: '17%',

      VirtualCollect: '22%',
      VirtualCollectTitle: '22%',

      LastConsult: '23%',
      LastConsultTitle: '23%',

      LastStatusPackage: '23%',
      LastStatusPackageTitle: '23%',

      Options: '100px',
      OptionsTitle: '100px'
    }
  }

  return {
    getWidthColumns
  };
}